export const DepositIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 2.5L8 14.5M8 14.5L4 10.5M8 14.5L12 10.5" stroke="white" />
      <rect opacity="0.5" x="2" y="3.5" width="4" height="1" fill="white" />
      <rect opacity="0.5" x="10" y="3.5" width="4" height="1" fill="white" />
    </svg>
  )
}
